export const courseScheduleData = [
  {
    grade: 'K2',
    gradeZh: '小一预备班',
    level: 'primary',
    classes: [
      { name: '', day: 'Sunday', dayZh: '星期日', time: '9am - 11am' },
    ],
  },
  {
    grade: 'P1',
    gradeZh: '小一',
    level: 'primary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Monday', dayZh: '星期一', time: '3pm - 5pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Saturday', dayZh: '星期六', time: '11am - 1pm' },
    ],
  },
  {
    grade: 'P2',
    gradeZh: '小二',
    level: 'primary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Wednesday', dayZh: '星期三', time: '5pm - 7pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Saturday', dayZh: '星期六', time: '9am - 11am' },
    ],
  },
  {
    grade: 'P3',
    gradeZh: '小三',
    level: 'primary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Friday', dayZh: '星期五', time: '5pm - 7pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Sunday', dayZh: '星期日', time: '1pm - 3pm' },
    ],
  },
  {
    grade: 'P4',
    gradeZh: '小四',
    level: 'primary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Monday', dayZh: '星期一', time: '5pm - 7pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Saturday', dayZh: '星期六', time: '9am - 11am' },
    ],
  },
  {
    grade: 'P5',
    gradeZh: '小五',
    level: 'primary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Thursday', dayZh: '星期四', time: '5:30pm - 7:30pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Sunday', dayZh: '星期日', time: '3pm - 5pm' },
    ],
  },
  {
    grade: 'P6',
    gradeZh: '小六',
    level: 'primary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Tuesday', dayZh: '星期二', time: '5pm - 7pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Friday', dayZh: '星期五', time: '5pm - 7pm' },
      { name: 'Class C', nameZh: 'C班', day: 'Saturday', dayZh: '星期六', time: '11am - 1pm' },
    ],
  },
  {
    grade: 'S1',
    gradeZh: '中一',
    level: 'secondary',
    classes: [
      { name: '', day: 'Saturday', dayZh: '星期六', time: '5pm - 7pm' },
    ],
  },
  {
    grade: 'S2',
    gradeZh: '中二',
    level: 'secondary',
    classes: [
      { name: '', day: 'Saturday', dayZh: '星期六', time: '3pm - 5pm' },
    ],
  },
  {
    grade: 'S3',
    gradeZh: '中三',
    level: 'secondary',
    classes: [
      { name: 'Class A', nameZh: 'A班', day: 'Friday', dayZh: '星期五', time: '7pm - 9pm' },
      { name: 'Class B', nameZh: 'B班', day: 'Saturday', dayZh: '星期六', time: '1pm - 3pm' },
    ],
  },
  {
    grade: 'S4',
    gradeZh: '中四',
    level: 'secondary',
    classes: [
      { name: '', day: 'Sunday', dayZh: '星期日', time: '11am - 1pm' },
    ],
  },
  {
    grade: 'S4 HCL',
    gradeZh: '中四高级华文',
    level: 'secondary',
    classes: [
      { name: '', day: 'Thursday', dayZh: '星期四', time: '7:30pm - 9:30pm' },
    ],
  },
];
